import React, { useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import '../../../Styles/list-Page.scss'
import editGreen from './../../../imgs/EditGreen.png'
import Delete from './../../../imgs/recycle.png'
import View from './../../../imgs/view.png'
import setingGreen from './../../../imgs/SettingGreen.png'
import {
    archiveParameterById,
    getParametersByDataModelId,
} from '../../../store/parameter/api'
import { getDataById, getDataModel } from '../../../store/model/api'
import { handleError } from '../../../utils/handleErrors'
import { FlowDetail } from '../FlowList/FlowDetail'
import { formatDate } from '../../../Services/dateFormat'
import ListPage from '../../Organisms/ListPage/ListPage'
import { ParameterListHeader } from './ParameterListHeader'
import { ParameterDetails } from './ParameterDetails'
import { getEntityVersionById } from '../../../store/common/api'
import { ArchivePopup } from '../../Organisms/Popups/General/ArchivePopup'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

const entityType = 'parameter'
export const ParameterList = (props) => {
    const [showPopup, setShowPopup] = useState(false)
    const [archivePopupId, setArchivePopupId] = useState(null)
    const [triggerRefresh, setTriggerRefresh] = useState(0)
    const [name, setName] = useState()
    const [key, setKey] = useState()
    const [versions, setVersions] = useState()
    const [dataModel, setDataModel] = useState()
    const [dataModels, setDataModels] = useState([])
    const [parameterDetail, setParameterDetail] = useState(null)
    const GROUP_NAMES_BY_KEY = {
        1: 'Client Characteristics',
        2: 'Creditworthiness',
        3: 'Product Class Characteristics',
        4: 'Solvency',
        5: 'Expense analysis',
        6: 'Income analysis',
        7: 'Limit level',
        8: 'Limits',
        9: 'Decision making',
        10: 'Term of sales',
        11: 'Global',
        12: 'Cross Sale',
    }
    const STATUSES_BY_KEY = {
        0: 'Archived',
        1: 'Draft',
        2: 'In review',
        3: 'Approved',
        4: 'Declined',
    }
    const history = useHistory()

    useEffect(() => {
        getDataModel().then((_dataModels) => {
            setDataModels(_dataModels)
            const dataModelId = localStorage.getItem('dataModelId')
            setDataModel(dataModelId || _dataModels?.[0]?._id)
            setTriggerRefresh((v) => ++v)
        })
    }, [])
    const openParameterDetail = (id) => {
        getEntityVersionById(id, entityType)
            .then((versions) => {
                setVersions(versions)
                if (versions && versions.length > 0) {
                    setParameterDetail(versions[0])
                }
            })
            .catch(handleError)
    }
    const viewParameter = (item) => {
        history.push(`${window.location.pathname}/${item.data._id}?type=view`)
    }

    const deleteParameter = () => {
        archiveParameterById(archivePopupId)
            .then((versions) => {
                setArchivePopupId(null)
                setVersions(versions)
                if (versions && versions.length > 0) {
                    setVersions(versions[0])
                }
                setTriggerRefresh((v) => ++v)
                toast.success('Parameter deleted successfully')
            })
            .catch(handleError)
    }

    const editDataItem = (item) => {
        getDataById({ id: item.data.modelId })
            .then(() => {
                setShowPopup(true)
                setName(item.data.name)
                setVersions(item.data.version)
                setKey(item.data.key)
            })
            .catch(handleError)
    }
    const closeParameterDetail = () => {
        setParameterDetail(false)
    }

    const parametersTableColumn = [
        { field: 'name', filter: true },
        {
            field: 'group',
            filter: true,
            valueGetter: (params) => {
                return GROUP_NAMES_BY_KEY[params.data.group]
            },
        },
        { headerName: 'Mapping Key', field: 'key', filter: true },
        { headerName: 'Default Value', field: 'defaultValue' },
        {
            field: 'status',
            filter: true,
            valueGetter: (params) => {
                return STATUSES_BY_KEY[params.data.status]
            },
        },
        {
            headerName: 'Last Modified By',
            field: 'user',
            filter: 'agDateColumnFilter',
        },
        {
            headerName: 'Last Modified Date',
            field: 'createdAt',
            filter: true,
            sort: true,
            valueGetter: (params) => {
                return formatDate(new Date(params.data.createdAt))
            },
        },
        {
            field: 'Actions',
            cellRenderer: (params) => {
                return (
                    <div className="icons">
                        <img
                            src={editGreen}
                            onClick={() => editDataItem(params)}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                        <img
                            src={setingGreen}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                openParameterDetail(params.data._id)
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                        <img
                            src={Delete}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                setArchivePopupId(params.data._id)
                            }}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                        <img
                            src={View}
                            onClick={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                                viewParameter(params)
                            }}
                            style={{ cursor: 'pointer', paddingRight: '5px' }}
                        />{' '}
                    </div>
                )
            },
        },
    ]
    return (
        <>
            <ArchivePopup
                isOpen={!!archivePopupId}
                togglePanel={setArchivePopupId}
                onDelete={() => deleteParameter()}
            ></ArchivePopup>
            <div className={'tableWrapper'}>
                {parameterDetail ? (
                    <ParameterDetails
                        details={parameterDetail}
                        versions={versions}
                        close={() => {
                            setParameterDetail(null)
                        }}
                    />
                ) : null}
                {dataModel ? (
                    <ListPage
                        pg="20"
                        triggerCall={triggerRefresh}
                        dataModelCall={getDataModel}
                        dataCall={() =>
                            getParametersByDataModelId(
                                { modelId: dataModel },
                                dataModels,
                            )
                        }
                        tableColumns={parametersTableColumn}
                        parameterPanel={FlowDetail}
                        parameterDetail={parameterDetail}
                        setParameterDetail={setParameterDetail}
                        closeParameterDetail={closeParameterDetail}
                        setOpenPanel={props.setOpenPanel}
                        editDataItem={editDataItem}
                        HeaderComponent={() => (
                            <ParameterListHeader
                                dataModel={dataModel}
                                setDataModel={(a) => {
                                    setDataModel(a)
                                    setTriggerRefresh((v) => ++v)
                                }}
                                dataModels={dataModels}
                            />
                        )}
                    />
                ) : null}
            </div>
        </>
    )
}
